export default __webpack_public_path__ + "static/media/header.990f960e.png";